import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

import { cleanEmptyParams } from "@/utilities/etc"

export const Route = createFileRoute("/_authenticated")({
  validateSearch: (
    search: Record<string, unknown>
  ): {
    qrLookupID: string | undefined
  } => {
    return cleanEmptyParams({
      qrLookupID: (search.qrLookupID as string) || "",
    })
  },
  loaderDeps: ({ search }) => {
    return { qrLookupID: search.qrLookupID }
  },
  beforeLoad: ({ context, search, location }) => {
    if (!context.isAuthenticated) {
      throw redirect({
        to: "/auth/sign-in",
        search: {
          redirect: location.href,
          qrLookupID: search.qrLookupID,
          phone: undefined,
          plate: undefined,
          conversionFlow: undefined,
          email: undefined,
        },
      })
    }
  },
  loader: ({ context, deps }) => {
    context.setDocumentThemeMode(deps.qrLookupID ? "whiteLabel" : "root")
  },
  component: Outlet,
})
